// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from "react";

const SvgCopy24 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<rect
			width={13.227}
			height={13.227}
			x={3.75}
			y={7.023}
			stroke="currentColor"
			strokeWidth={1.5}
			rx={2.25}
		/>
		<path
			stroke="currentColor"
			strokeWidth={1.5}
			d="M7.91 5.455V5a2 2 0 0 1 2-2H19a2 2 0 0 1 2 2v9.09a2 2 0 0 1-2 2h-.454"
		/>
	</svg>
);
export default SvgCopy24;
